<template>
    <div class="login">
        <div class="background-image"></div>

        <div class="login__content">
            <form v-if="loginState === 'passwordForgot'" @submit.prevent="changePassword">
                <h2>Glemt adgangskode</h2>
                <div class="form__row">
                    <icon name="envelope" />
                    <label for="email" class="visually-hidden">E-mail</label>
                    <input type="email" id="email" placeholder="E-mail" required autofocus autocomplete="username" inputmode="email" v-model="user.email" />
                </div>
                <div class="form__row">
                    <button type="submit" class="button-blue login__button">Nulstil adgangskode</button>
                </div>
                <div class="form__row">
                    <button type="button" class="login__fake-link" @click="showLogin()"><strong>↩︎</strong>&nbsp;&nbsp;&nbsp;Fortryd</button>
                </div>
            </form>
            <template v-else-if="loginState === 'passwordReset'">
                <h2>Adgangskode nulstillet</h2>
                <icon name="paper-plane" class="huge-svg fill-feedback" />
                <p>Hvis du er oprettet som bruger, modtager du om kort tid en e-mail med din nye adgangskode.<br />
                E-mailen er sendt til <u>{{ user.email }}</u>.</p>
                <button type="button" class="login__fake-link" @click="showLogin()">Login</button>
            </template>
            <form v-else-if="loginState === 'organizationSelect'" @submit.prevent="chooseOrganization">
                <h2>Vælg forsyning/kommune</h2>
                <div class="form__row">
                    <div class="drop-down">
                        <select required autofocus v-model="selectedOrganization" @change="selectOrganization($event)">
                            <option value="" disabled>Vælg forsyning/kommune</option>
                            <option v-for="organization in organizations" :key="organization.id" :value="organization.id" :selected="organization.id">{{ organization.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="form__row">
                    <button type="submit" class="button-blue login__button">Vælg</button>
                </div>
            </form>
            <template v-else>
                <div class="login__system">
                    <icon name="astra-logo" />
                    <h1>ASTRA/<span>Administration</span></h1>
                </div>
                <form @submit.prevent="loginUser">
                    <div class="form__row">
                        <icon name="user" />
                        <label for="username" class="visually-hidden">Brugernavn</label>
                        <input type="text" id="username" placeholder="E-mail" required autofocus autocomplete="username" inputmode="email" v-model="user.username" />
                    </div>
                    <div class="form__row">
                        <icon name="locked" />
                        <label for="password" class="visually-hidden">Adgangskode</label>
                        <input type="password" id="password" placeholder="Adgangskode" required autocomplete="current-password" v-model="user.password" />
                    </div>
                    <div class="form__row">
                        <button type="submit" class="button-blue login__button">
                            Log ind
                            <div v-if="loading" class="login__loader"></div>
                        </button>
                    </div>
                    <div class="form__row">
                        <button type="button" class="login__fake-link" @click="passwordForgot()">Glemt adgangskode?</button>
                    </div>
                    <p class="login__error" v-if="error">{{ errorMessage }}</p>
                </form>
            </template>
        </div>

        <div class="powered-by">
            <icon name="niraslogo" class="logo niraslogo" />
        </div>

        <modal v-if="showModal" :type="modalType" :data="user.username" @close="showModal = false" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import modal from './../components/shared/modal/modal.vue'

export default {
    name: 'login',
    components: {
        modal
    },
    data () {
        return {
            user: {
                email: '',
                username: '',
                password: '',
                rememberme: false
            },
            loginState: 'login',
            errorMessage: 'Ingen fejl',
            error: false,
            selectedOrganization: '',
            organizations: [],
            claims: null,
            showModal: false,
            modalType: null,
            loading: false
        }
    },
    methods: {
        ...mapActions({
            login: 'login',
            setUserProperties: 'setUserProperties',
            getOrganizationList: 'getCurrentOrganizationList',
            changeOrganizationContext: 'changeOrganizationContext',
            setSelectedOrganizationId: 'setSelectedOrganizationId',
            getCurrentUserInfo: 'getCurrentUserInfo',
            setNewPasswordAsync: 'setNewPasswordAsync'
        }),

        loginUser () {
            this.error = false

            const _self = this

            if (this.user.username.length > 0 && this.user.password.length > 0) {
                this.loading = true
                this.login(this.user)
                    .then((response) => {
                        _self.claims = { claims: response }
                        return { claims: response, organizationList: null }
                    })
                    .then((data) => {
                        return new Promise((resolve, reject) => {
                            _self.getOrganizationList()
                                .then((response) => {
                                    if (!response || response.length === 0) {
                                        this.loading = false
                                        reject(new Error('No dataowner attached to user'))
                                    }
                                    data.organizationList = response
                                    resolve(data)
                                })
                        })
                    })
                    .then((data) => {
                        return new Promise((resolve, reject) => {
                            let selectedOrganizationId = null
                            for (let i in data.claims) {
                                if (data.claims[i].type === 'SelectedOrganization') {
                                    selectedOrganizationId = data.claims[i].value
                                }
                            }
                            let selectedOrganizationInfo = data.organizationList.filter(i => i.id.toLocaleLowerCase() === selectedOrganizationId.toLocaleLowerCase())
                            if (selectedOrganizationInfo.length > 0 && selectedOrganizationInfo[0].isDataOwner) {
                                _self.setSelectedOrganizationId(selectedOrganizationId)
                                    .then(() => {
                                        _self.getCurrentUserInfo(data)
                                            .then(() => {
                                                this.$router.push({ name: 'administration' })
                                                resolve(data)
                                            })
                                    })
                            } else {
                                selectedOrganizationInfo = data.organizationList.filter(i => i.isDataOwner)
                                if (selectedOrganizationInfo.length === 0) {
                                    this.loading = false
                                    throw new Error('user has no access to dataowner organization')
                                } else if (selectedOrganizationInfo.length === 1) {
                                    _self.changeOrganizationContext(selectedOrganizationInfo[0].id)
                                        .then((response) => {
                                            _self.claims = { claims: response.data }
                                            _self.setSelectedOrganizationId(selectedOrganizationInfo[0].id)
                                                .then(() => {
                                                    _self.getCurrentUserInfo(data)
                                                        .then(() => {
                                                            this.$router.push({ name: 'administration' })
                                                            resolve(data)
                                                        })
                                                })
                                        })
                                } else if (selectedOrganizationInfo.length > 1) {
                                    _self.organizations = selectedOrganizationInfo.sort((a, b) => a.name.localeCompare(b.name, 'da'))
                                    _self.loginState = 'organizationSelect'
                                }
                            }
                        })
                    })
                    .catch((error) => {
                        this.loading = false
                        this.error = true
                        this.errorMessage = 'Forkert brugernavn eller kodeord'
                        console.error(error)
                    })
            }
        },
        selectOrganization ($event) {
            this.selectedOrganization = this.organizations[$event.target.selectedIndex - 1].id
            this.setSelectedOrganizationId(this.selectedOrganization)
        },
        chooseOrganization () {
            const _self = this
            if (this.selectedOrganization) {
                new Promise((resolve, reject) => {
                    this.changeOrganizationContext(this.selectedOrganization)
                        .then((response) => {
                            _self.claims = { claims: response.data }
                            _self.setSelectedOrganizationId(_self.selectedOrganization)
                                .then(() => {
                                    _self.getCurrentUserInfo(_self.claims)
                                        .then((response) => {
                                            this.$router.push({ name: 'administration' })
                                            resolve(response)
                                        })
                                })
                        })
                }).catch((error) => {
                    console.error('Fejl i valg af organisation', error)
                })
            }
        },
        passwordForgot () {
            this.loginState = 'passwordForgot'
        },
        showLogin () {
            this.loginState = 'login'
        },
        changePassword () {
            new Promise((resolve, reject) => {
                resolve(this.setNewPasswordAsync(this.user.email))
            })
                .then(() => {
                    this.loginState = 'passwordReset'
                    setTimeout(() => {
                        this.loginState = 'login'
                    }, 3000)
                })
        }
    },
    created () {
        this.loginState = 'login'
        if (this.$route.query.loggedOut === '1') {
            this.showModal = true
            this.modalType = 'login-modal-loggedout'
        }
    }
}
</script>

<style lang="scss">
@import '../scss/utils/colors';
@import '../scss/utils/media-queries';

.login {
    align-items: center;
    display: grid;
    gap: 24px;
    grid-template-columns: 360px;
    grid-template-rows: auto min-content;
    justify-content: center;
    min-height: 100vh;
    padding-bottom: 12px;
    padding-top: 12px;
    position: relative;

    .background-image {
        // background: url(../assets/images/ASTRA_1920x1200px.jpg) no-repeat 50% 50%;
        background: url(../assets/images/ASTRA_1920x1200px2.jpg) no-repeat 50% 50%;
        // background: url(../assets/images/ASTRA_1920x1200px3.jpg) no-repeat 50% 50%;
        // background: url(../assets/images/ASTRA_1920x1200px4.jpg) no-repeat 50% 50%;
        background-size: cover;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: -1;

        // &::after {
        //   background: black;
        //   content: '';
        //   height: 100%;
        //   left: 0;
        //   opacity: 0.5;
        //   position: absolute;
        //   top: 0;
        //   width: 100%;
        // }
    }

    &__content {
        background-color: #fff;
        border-radius: 4px;
        box-shadow:
            0.3px 0.3px 0.7px rgba(0, 0, 0, 0.025),
            0.8px 0.8px 1.6px rgba(0, 0, 0, 0.036),
            1.5px 1.5px 3px rgba(0, 0, 0, 0.045),
            2.7px 2.7px 5.4px rgba(0, 0, 0, 0.054),
            5px 5px 10px rgba(0, 0, 0, 0.065),
            12px 12px 24px rgba(0, 0, 0, 0.09);
        padding: 1.5em;
        text-align: center;
        width: 100%;

        h1 {
            margin-bottom: 0.5em;
            text-transform: uppercase;

            span {
                font-weight: 400;
            }
        }
        h2 {
            margin-bottom: 0.85em;
        }
        p {
            margin-bottom: 0;
        }
        form {
            margin-top: 24px;
        }
    }
    &__system {
        margin-bottom: 24px;

        .icon-astra-logo {
            height: 65px;
            margin-bottom: 24px;
            width: 180px;
        }
    }

    .form__row {
        margin-bottom: 0.5em;
        margin-top: 0.5em;
        max-width: 480px;
        position: relative;

        .icon-user {
            fill: $dark-gray;
            height: 24px;
            left: 12px;
            position: absolute;
            top: calc(50% - 12px);
            width: 24px;
        }
        .icon-locked,
        .icon-envelope {
            border: 2px solid #848589;
            border-radius: 50%;
            fill: $dark-gray;
            height: 24px;
            left: 12px;
            padding: 3px;
            position: absolute;
            top: calc(50% - 12px);
            width: 24px;
        }

        input {
            border-radius: 3px;
            height: auto;
            line-height: 1.5em;
            padding: 0.875em 0.75em 0.875em calc(0.75em + 24px + 0.75em);
            width: 100%;

            &:hover {
                box-shadow: none;
            }
            &:focus {
                border-color: #848589;
                outline: 3px solid rgba(34, 69, 115, 0.4);
                outline-offset: 2px;
            }
        }
        select {
            height: auto;
            margin: auto;
            margin-bottom: 8px;
            padding: 14px 1.5rem 12px 0.5rem;
            width: 100%;
        }
    }

    &__button {
        background-color: lighten($blue, 39%);
        box-shadow: none;
        color: #222;
        filter: none;
        font-size: inherit;
        line-height: 1.25em;
        margin-top: 12px;
        padding: 0.5em 1.125em;
    }
    &__fake-link {
        color: $blue;
        margin-top: 36px;
    }

    &__error {
        color: red;
        margin-bottom: 1.5em;
        margin-top: 0.75em;
    }

    .powered-by {
        color: #fff;
        font-size: 1.28rem;
        line-height: 1.563em;
        text-align: center;

        svg {
            height: 34px;
            width: 100px;

            path {
                fill: currentColor;
            }
        }
    }

    &__loader {
        animation: mapspin 1s linear infinite;
        border: 3px solid rgba(#539ebc,0.25);
        border-bottom-color: #539ebc;
        border-top-color: #539ebc;
        border-radius: 50%;
        height: 24px;
        margin: -2px 0 -2px 10px;
        width: 24px;
    }

    @keyframes mapspin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue